/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FoldersControllerFindAllQueryResponse, FoldersControllerFindAllQueryParams, FoldersControllerFindAll401, FoldersControllerFindAll403 } from "../../models/foldersController/FoldersControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { foldersControllerFindAll } from "../../clients/foldersService/foldersControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const foldersControllerFindAllQueryKey = (params: FoldersControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/folders'
}, ...(params ? [params] : [])] as const;
export type FoldersControllerFindAllQueryKey = ReturnType<typeof foldersControllerFindAllQueryKey>;
export function foldersControllerFindAllQueryOptions(params?: FoldersControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = foldersControllerFindAllQueryKey(params);
  return queryOptions<FoldersControllerFindAllQueryResponse, ResponseErrorConfig<FoldersControllerFindAll401 | FoldersControllerFindAll403>, FoldersControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return foldersControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all folders
 * {@link /api/v1/folders}
 */
export function useFoldersControllerFindAll<TData = FoldersControllerFindAllQueryResponse, TQueryData = FoldersControllerFindAllQueryResponse, TQueryKey extends QueryKey = FoldersControllerFindAllQueryKey>(params?: FoldersControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<FoldersControllerFindAllQueryResponse, ResponseErrorConfig<FoldersControllerFindAll401 | FoldersControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? foldersControllerFindAllQueryKey(params);
  const query = useQuery({
    ...foldersControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FoldersControllerFindAll401 | FoldersControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}